import { Card } from "@blueprintjs/core";
import styled from "styled-components";
const CustomCard = styled(Card)<{
  padding?: string;
  borderRadius?: string;
  marginTop?: string;
  minHeight?: string;
  maxWidth?: string;
}>`
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : "20px")};
  padding: ${({ padding }) => (padding ? padding : "10px 20px")};
  border-radius: ${({ borderRadius }) =>
    borderRadius ? borderRadius : "15px"};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-height: ${({ minHeight }) => (minHeight ? minHeight : "fit-content")};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "100%")};
`;
export default CustomCard;
